import { render, staticRenderFns } from "./ViewerImages.vue?vue&type=template&id=7044a9ee&scoped=true"
import script from "./ViewerImages.vue?vue&type=script&lang=js"
export * from "./ViewerImages.vue?vue&type=script&lang=js"
import style0 from "./ViewerImages.vue?vue&type=style&index=0&id=7044a9ee&prod&lang=css"
import style1 from "./ViewerImages.vue?vue&type=style&index=1&id=7044a9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044a9ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVideoPreview: require('/app/components/ProductVideoPreview.vue').default,SsrCarousel: require('/app/node_modules/vue-ssr-carousel/index.js').default,ProductVideoShelf: require('/app/components/ProductVideoShelf.vue').default,CustomerMediaTeaser: require('/app/components/CustomerMediaTeaser.vue').default,CustomerMediaRow: require('/app/components/CustomerMediaRow.vue').default,ModalVideo: require('/app/components/ModalVideo.vue').default})
